`use strict`;

document.addEventListener(`DOMContentLoaded`, () => {

    const toggles = [];

    const buttons = document.querySelectorAll('.button.--read-more');
    if (!buttons) {
        return;
    }

    buttons.forEach((button, key) => {

        toggles[key] = new Draad_Toggle(button);

    });
});